import React from "react";

const OrderDetailTopCardSkeleton = () => {
  return (
    <div className="h-fit flex-1 p-4 sm:p-6 lg:p-9 bg-white rounded-[1.25rem] shadow-sm border border-light-blue min-h-[300px] animate-pulse">
      <div className="flex flex-col gap-6 pt-4 mb-10">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:gap-0">
          <div className="flex flex-col w-3/4 gap-4">
            {/* Title & Description */}
            <div className="w-40 h-8 bg-gray-200 rounded lg:w-72"></div>
            <div className="h-6 bg-gray-200 rounded max-w-[90%] sm:w-full"></div>
          </div>
          {/* Price */}
          <div className="w-20 h-8 bg-gray-200 rounded"></div>
        </div>

        {/* Task Details */}
        <div>
          {/* Mobile layout */}
          <div className="flex flex-col gap-2 sm:hidden">
            <div className="flex items-center justify-between">
              <div className="w-20 h-5 bg-gray-200 rounded"></div>
              <div className="w-20 h-5 bg-gray-200 rounded"></div>
            </div>
            <div className="flex items-center justify-between">
              <div className="w-20 h-5 bg-gray-200 rounded"></div>
              <div className="w-20 h-5 bg-gray-200 rounded"></div>
            </div>
            <div className="flex items-center justify-between">
              <div className="w-20 h-5 bg-gray-200 rounded"></div>
              <div className="w-20 h-5 bg-gray-200 rounded"></div>
            </div>
          </div>

          {/* Desktop layout */}
          <div className="hidden sm:flex gap-[3rem]">
            <div className="flex flex-col gap-2">
              <div className="w-20 h-5 bg-gray-200 rounded"></div>
              <div className="w-20 h-5 bg-gray-200 rounded"></div>
              <div className="w-20 h-5 bg-gray-200 rounded"></div>
            </div>
            <div className="flex flex-col gap-2">
              <div className="w-20 h-5 bg-gray-200 rounded"></div>
              <div className="w-20 h-5 bg-gray-200 rounded"></div>
              <div className="w-20 h-5 bg-gray-200 rounded"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDetailTopCardSkeleton;
